<template>
  <div class="toggle-wrap" @mouseenter="showIconWrap" @mouseleave="hiddenIconWrap">
    <div class="icons-wrap" v-if="showBlockWrap" :class="[iconWrapFlage?'show':'hidden']">
      <div class="toggle-icon">
        <a href="https://coocaa.feishu.cn/share/base/shrcn4gZuEjSGBPr6MDh9HC11Ef" target="_blank">
          <el-tooltip
            class="item"
            effect="dark"
            content="我要提建议"
            placement="right"
          >
            <i class="el-icon-document"></i>
          </el-tooltip>
        </a>
      </div>
      <div class="toggle-icon">
        <a href="https://coocaa.feishu.cn/share/base/shrcnndFG9rAfmt513U7rQhRALd" target="_blank">
          <el-tooltip
            class="item"
            effect="dark"
            content="我有需求"
            placement="right"
          >
            <i class="el-icon-tickets"></i>
          </el-tooltip>
        </a>
      </div>
      <div class="toggle-icon">
        <a href="https://coocaa.feishu.cn/share/base/shrcnP5RRphCZNPp66qzhFe4fKf" target="_blank">
          <el-tooltip
            class="item"
            effect="dark"
            content="我要提BUG"
            placement="right"
          >
            <i class="el-icon-question"></i>
          </el-tooltip>
        </a>
      </div>
      <div class="toggle-icon">
        <a :href="`/kanban-config-view?id=65&preview=true&from=${$route.meta.tab}`" target="_blank">
          <el-tooltip
            class="item"
            effect="dark"
            content="看板使用效果"
            placement="right"
          >
            <i class="el-icon-view"></i>
          </el-tooltip>
        </a>
        <!-- <a :href="`https://databoard.coocaa.com/kanban-config-view?id=65&preview=true&from=${$route.meta.tab}`" target="_blank">
          <el-tooltip
            class="item"
            effect="dark"
            content="看板使用效果"
            placement="right"
          >
            <i class="el-icon-view"></i>
          </el-tooltip>
        </a> -->
      </div>
      <div class="toggle-icon">
        <a href="https://coocaa.feishu.cn/wiki/wikcnmiX5Iy8Df0pcABpkNK7OQ7" target="_blank">
          <el-tooltip
            class="item"
            effect="dark"
            content="我想做看板"
            placement="right"
          >
            <i class="el-icon-info"></i>
          </el-tooltip>
        </a>
      </div>
    </div>
    <div class="toggle-info">
      <i class="el-icon-menu" v-show="!iconWrapFlage" @click="showIconWrap"></i>
      <i class="el-icon-close" v-show="iconWrapFlage" @click="hiddenIconWrap"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  props: [

  ],
  data () {
    return {
      iconWrapFlage: false,
      setTimeoutFlage: null,
      showBlockWrap: false
    }
  },
  computed: {

  },
  created () {

  },
  mounted () {

  },
  watch: {

  },
  methods: {
    showIconWrap () {
      clearTimeout(this.setTimeoutFlage)
      this.showBlockWrap = true
      this.setTimeoutFlage = setTimeout(() => {
        this.iconWrapFlage = true
      }, 100)
    },
    hiddenIconWrap () {
      clearTimeout(this.setTimeoutFlage)
      this.iconWrapFlage = false
      this.setTimeoutFlage = setTimeout(() => {
        this.showBlockWrap = false
      }, 400)
    }
  },
  components: {

  }
}
</script>
<style scoped lang="stylus">
.toggle-wrap
  position: fixed
  right: 3%
  bottom 5%
  .toggle-icon
    width 30px
    height 30px
    display flex
    align-items center
    justify-content: center
    cursor pointer
    margin-bottom: 10px
  a
    width 100%
    height 100%
  i
    border-radius: 50%
    overflow: hidden
    background-color: #1c18398f
    width 100%
    height 100%
    text-align center
    line-height: 30px
    font-size: 18px
    color #551a8b
  .icons-wrap
    transition: all 0.4s
    position: relative
    &.show
      opacity 1
      bottom .5rem
    &.hidden
      opacity 0
      bottom 0
.toggle-info
  background-color: #1c18398f
  cursor pointer
  width 30px
  border-radius: 50%
  overflow: hidden
  height 30px
  color #551a8b
</style>
